import * as React from "react";
import { Link } from "react-router-dom";

/**
 * A wrapper around the Link component or the builtin anchor (a) component
 * 
 * Usage:
 * <CustomLink linkProps={href: '/pharmacy', className: 'col-12'>Link text</CustomLink>
 * <CustomLink linkProps={to:{pathName: 'https://my-tst.bswhealth/rxHome'}}>Link text</CustomLink>
 * 
 */
export default class CustomLink extends React.Component {

    constructor(props) {
        super(props);
    }
    
    render() {
        const { linkProps, children } = this.props;
        if (linkProps.to) {
            return (
                <Link {...linkProps}>
                    {children}
                </Link>
            );
        }
        else {
            return (
                <a {...linkProps}>
                    {children}
                </a>
            );
        }
    }
}